module.exports = __webpack_public_path__ + "img/example.322e7613.jpg";